export function initDatadog() {
    // datadog override window.onunhandledrejection, and our ErrorBoundary also overrides it
    // -> race condition
    // ensure a sequential initialization through this Promise
    let datadogInitializedPromise = Promise.resolve();

    if (process.env.REACT_APP_DATADOG_ID && process.env.REACT_APP_DATADOG_TOKEN) {
        datadogInitializedPromise = import('@datadog/browser-rum')
            .then(({datadogRum}) => {
                datadogRum.init({
                    applicationId: process.env.REACT_APP_DATADOG_ID!,
                    clientToken: process.env.REACT_APP_DATADOG_TOKEN!,
                    service: 'provider',
                    sampleRate: 100,
                    trackInteractions: true,
                    env: process.env.REACT_APP_NODE_ENV
                });
            }).catch((e) => {
                console.warn('Datadog fails to initialize, continue to render React app as usual');
                console.error(e);
                return Promise.resolve();
            });
    }

    return datadogInitializedPromise;
}
